import { userProfileConstants } from '../../_constants';
import { userProfileService } from '../../_services';
import { userProfileAction } from './getUserProfile.action';

export const updateDobInfoAction = {
    updateDobInfoHandler
};

function updateDobInfoHandler(data) {
    return dispatch => {
        dispatch(request());
        userProfileService.updateDobInfoHandler(data)
            .then(
                updateDobInfo => {
                    dispatch(userProfileAction.getUserProfileHandler())
                    dispatch(success(updateDobInfo));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: userProfileConstants.REQUEST_UPDATE_DOB} }
    function success(updateDobInfo) { return { type: userProfileConstants.RECEIVE_UPDATE_DOB, updateDobInfo } }
    function failure(error) { return { type: userProfileConstants.UPDATE_DOB_ERROR, error } }
}



// WEBPACK FOOTER //
// ./src/_actions/UserProfile/updateDobInfo.action.js